import { twMerge } from "tailwind-merge";
import {
  CatalogLink,
  CatalogAutoplayButton,
  CatalogPagingButton,
} from "catalog/CatalogNavigations";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { Anime, Image } from "components/elements";
import { useCatalog } from "catalog/Catalog.context";

const NAVMENUS = [
  { label: "COMPANY", link: "/company/about/about-main", value: "company" },
  {
    label: "PRODUCTS",
    link: "/products/cooking/cooking-contents/cooking-tools",
    value: "products",
  },
  { label: "SHOW ROOM", link: "show-room/main", value: "show-room" },
];

const COMPANY_MENUS = [
  { label: "About Shinsung", value: "about", link: "/company/about/about-main" },
  { label: "History", value: "history", link: "/company/history" },
  { label: "OEM & ODM", value: "oem", link: "/company/oem/overview" },
];
const SHOWROOM_MENUS = [
  { label: "Cooking Tools", value: "tools", link: "/show-room/content/tools" },
  { label: "Silicone Zipper Bags", value: "silicone", link: "/show-room/content/silicone" },
  { label: "Bib / Teether", value: "bib", link: "/show-room/content/bib" },
];

export default function GlobalNavigation() {
  const { pageSlug1, pageSlug2, pageSlug3 } = useParams();

  const isCover = pageSlug1 == "cover";
  const isCatalogIndex = pageSlug1 == "catalog-index";
  const isCompanyAbout = pageSlug3 == "about-contents";
  const isAboutMain = pageSlug3 == "about-main";
  const isLastPage = pageSlug1 == "last";
  const isProductMain = pageSlug1 == "products" && pageSlug3.includes("main");
  const isShowroomMain = pageSlug1 == "show-room" && pageSlug2.includes("main");
  const isLineup = pageSlug1 == "lineup";
  const isShowroom = pageSlug1 == "show-room";
  const isCompany = pageSlug1 == "company";

  //현재 경로가 show-room/content 일때 SHOWROOM_MENUS
  //현재 경로가 company일때 COMPANY_MENUS
  //둘 다 아니면 메뉴바 안보임
  const currentBottomMenus = isShowroom ? SHOWROOM_MENUS : isCompany ? COMPANY_MENUS : null;
  const currentControlBtnColor = isShowroomMain || isLineup ? "" : "-color";

  if (isCover || isLastPage) return;
  return (
    <>
      <div className="absolute left-0 right-0 top-0">
        {!isCatalogIndex && (
          <div className="absolute left-0 top-0 z-10 w-[75px]">
            <CatalogLink to="/">
              <Image src="home.png" />
            </CatalogLink>
            <CatalogLink to="/catalog-index">
              <Image src="more.png" />
            </CatalogLink>
          </div>
        )}

        {!isLineup && (
          <header
            className={twMerge(
              "mx-[168px] flex h-[75px] w-full items-center gap-8 bg-transparent *:pointer-events-auto",
              isAboutMain && "bg-white",
            )}
          >
            <div className="flex items-center">
              {!isCatalogIndex && !isCompanyAbout && !isProductMain && (
                <nav
                  className={twMerge(
                    "flex gap-[43px]  text-[23px] font-semibold text-[#989898]",
                    isShowroomMain && "text-white",
                  )}
                >
                  {NAVMENUS.map((menu) => {
                    const isCurrentMenu = menu.value === pageSlug1;
                    return (
                      <CatalogLink
                        className={twMerge(
                          "font-lato",
                          isCurrentMenu && "font-bold text-[var(--primary)]",
                        )}
                        key={menu.label}
                        to={menu.link}
                      >
                        {menu.label}
                      </CatalogLink>
                    );
                  })}
                </nav>
              )}
              <div
                className={twMerge(
                  "absolute right-[84px] h-[35px] w-[266px]",
                  isCatalogIndex && "left-10",
                )}
              >
                <Image src="nav-logo.png" className="h-full w-full object-cover" />
              </div>
            </div>
          </header>
        )}
      </div>

      {/* 하단 네비게이션 */}
      <nav
        className={twMerge(
          "absolute bottom-0 left-0 z-[999px] flex  h-[86px] w-full justify-between px-10",
          isCompany && "shadow-[0_-4px_10px_rgba(0,0,0,0.1)]",
          isShowroom && !isShowroomMain && "shadow-[0_-4px_10px_rgba(0,0,0,0.1)]",
        )}
      >
        <CatalogPagingButton direction="prev" className="z-[999] h-full disabled:opacity-50">
          <Image
            src={`next-nav${currentControlBtnColor}.png`}
            alt="이전으로"
            className="rotate-180"
          />
        </CatalogPagingButton>
        <nav className="flex font-semibold text-[#989898] ">
          {currentBottomMenus &&
            currentBottomMenus.map((menu, idx) => {
              const currentView = pageSlug2 === menu.value || pageSlug3 === menu.value;

              const isLastBtn = idx == COMPANY_MENUS.length - 1;
              if (isShowroomMain) return;
              return (
                <CatalogLink
                  className={twMerge(
                    "font-lato relative flex h-full w-[205px] flex-col items-center justify-center",
                    !isLastBtn && " btn-after",
                  )}
                  key={menu.value}
                  to={menu.link}
                >
                  <span
                    className={twMerge(
                      "absolute top-0 h-2 w-full",
                      currentView && "bg-[var(--primary)]",
                    )}
                  />
                  <span
                    className={twMerge(
                      "block text-lg",
                      currentView && "font-bold text-[var(--primary)]",
                    )}
                  >
                    {menu.label}
                  </span>
                </CatalogLink>
              );
            })}
        </nav>
        <CatalogPagingButton direction="next" className="z-[999] h-full disabled:opacity-50">
          <Image src={`next-nav${currentControlBtnColor}.png`} alt="다음으로" className="" />
        </CatalogPagingButton>
      </nav>
    </>
  );
}
